import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=b65093ca&scoped=true&"
import script from "./ListTable.vue?vue&type=script&lang=js&"
export * from "./ListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65093ca",
  null
  
)

export default component.exports